import 'babel-polyfill'
import 'unfetch/polyfill'
import React from 'react'
import { render } from 'react-dom'
import Root from './containers/Root'
import boot from 'lib/boot'
import './index.css'

boot()

/**
 * Render the root container.
 */

render(<Root />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./index.js